import type { FaireProductEntity } from "../../entity_types/product";

export const p_bhw5g37tpm: FaireProductEntity = {
  token: "p_bhw5g37tpm",
  type: "product",
  name: "Inlaid CZ 18K Gold Plated Stainless Steel Ring - FGS",
  brandToken: "b_nex9pcmkzj",
  brandName: "Mio Queena",
  imageUrl:
    "https://cdn.faire.com/fastly/ffd4145df4d1cfa65922ce10e91d11147bec25fa361d0b299cfea365587afe8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5e2835709456309e3d7a2a963ad38ac892b977d61871b95c5f959481e488203f.jpeg",
    "https://cdn.faire.com/fastly/572fff7296ee1c642dba807fff43a78668d12ff01422055716d1f7f2abccc43e.jpeg",
    "https://cdn.faire.com/fastly/59873105ad96039208c841f76b7ee1e652eaf60b02eef18889867d8af54b2437.jpeg",
    "https://cdn.faire.com/fastly/53c624ffea8073acd38da0325a463ca647eb3e5592c4658eb57f113ecdf526fd.jpeg",
    "https://cdn.faire.com/fastly/f64876af1ba73e9c2ff025d882c698265ba8b86b2efdeb504ed22ddc00882821.jpeg",
    "https://cdn.faire.com/fastly/09821b08c6f88b59978f8517f371df8c40e8a30c3025495d327d4ce13170328c.jpeg",
    "https://cdn.faire.com/fastly/b33cefda844ff2ffe93152327049b32b2623aa01a7d48033a3fe3071512595e8.jpeg",
    "https://cdn.faire.com/fastly/f25cad0321332e4dc4e0647dcc586b036e1d1c9b207df01a80edb31df55b4a60.jpeg",
  ],
  priceDollars: 6.06,
  description:
    "Type: Ring\nMaterial : Stainless steel ,Cubic zirconia,18K gold plated\n\nSize : height-7.5mm ,Please refer to Size chart of rings\n\nProcess: Vacuum electroplating and manual polishing,Non - tarnish\nSurface : High Polish\n★Made of high quality stainless steel,Lead-free,Harmless to Human Body.\n★Perfect jewelry gifts \n",
  tags: [],
  msrpDollars: 15.13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:54:31.002Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
